/**
 * Producer portal pilot mode configuration.
 * Controls which features are visible in the producer portal UI.
 * All values default to pilot-safe settings (most features hidden).
 */

/** Keys stored in app_settings */
export const PILOT_SETTINGS_KEYS = [
  'producer_portal.pilot_mode',
  'producer_portal.show_shop',
  'producer_portal.show_orders',
  'producer_portal.show_shipping',
  'producer_portal.show_billing',
  'producer_portal.show_team',
  'producer_portal.show_verification',
] as const;

/** Fallback when DB rows are missing — pilot mode ON, extras OFF */
export const PILOT_DEFAULTS: Record<string, boolean> = {
  'producer_portal.pilot_mode': true,
  'producer_portal.show_shop': false,
  'producer_portal.show_orders': false,
  'producer_portal.show_shipping': false,
  'producer_portal.show_billing': false,
  'producer_portal.show_team': false,
  'producer_portal.show_verification': false,
  
};

/** Route segments that map to feature keys */
export const ROUTE_FEATURE_MAP: Record<string, string> = {
  shop: 'producer_portal.show_shop',
  billing: 'producer_portal.show_billing',
  team: 'producer_portal.show_team',
  verifiering: 'producer_portal.show_verification',
  
};

/** Nav items to hide when their feature key is false */
export const NAV_FEATURE_MAP: Record<string, string> = {
  'Gårdsbutik': 'producer_portal.show_shop',
  'Abonnemang': 'producer_portal.show_billing',
  'Personer & roller': 'producer_portal.show_team',
  'Verifiering & juridik': 'producer_portal.show_verification',
  
};
